import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';
import {MaterialFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {useMemo} from 'react';

export const useMaterialFilterSection = ({
  data,
  activeFilters,
  setFilter,
}: {
  data: MaterialFilterSection;
  activeFilters: Map<string, Array<string> | undefined>;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
  }) => void;
}) => {
  const {materialFilter} = data;
  const materialLabel = materialFilter!.label!;
  const materialSlug = materialFilter!.slug!;
  const materialValues = materialFilter?.values;

  const normalizedMaterialValues = useMemo(
    () =>
      materialValues
        ? materialValues.map(({id, label, productCount, slug}) => ({
            count: productCount,
            id: `${id}`,
            label,
            slug,
          }))
        : undefined,
    [materialValues],
  );

  const shouldUseSlugifiedAttributeFilters = useIsSoftFeatureToggleActive(
    'attribute_filters_slugified_ids',
  );

  const handleMaterialClick = (itemId: string, itemSlug?: string) => {
    setFilter({
      filterId: itemId,
      filterSection: materialSlug,
      ...(shouldUseSlugifiedAttributeFilters && {
        filterSlug: itemSlug,
      }),
    });
  };

  const activeItemIds = (activeFilters.get(materialSlug) ?? []).filter(value =>
    (normalizedMaterialValues || []).map(({id}) => id).includes(value),
  );

  return {
    materialLabel,
    materialSlug,
    materialValues,
    normalizedMaterialValues: normalizedMaterialValues as unknown as Array<{
      count?: number;
      id: string;
      label: string;
    }>,
    activeItemIds,
    handleMaterialClick,
  };
};
